<template>
  <div id="ecommerce">
    <div v-if="isSelectedBot">
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab href="#Products" ripple>{{ $t('Products') }}</v-tab>
        <v-tab v-if="showProductAnalytic" href="#ProductAnalytics" ripple>{{
          $t('Sales Report')
        }}</v-tab>
        <v-tab href="#CartSummary" ripple>{{ $t('Cart Summary') }}</v-tab>
        <v-tab href="#ecommerce-order-summary" ripple>{{ $t('Order Summary') }}</v-tab>
        <template v-if="selectedBot.theme == 'nvbb'">
          <v-tab href="#nvbb-order-summary" ripple>{{ $t('Drink Summary') }}</v-tab>
        </template>
        <v-tab ripple href="#aston-ads" v-if="$aston.astonpages.includes(selectedBot.pageid)">{{
          $t('Aston')
        }}</v-tab>
        <v-tab ripple href="#AstonAuction" v-if="$aston.astonpages.includes(selectedBot.pageid)">{{
          $t('Auction')
        }}</v-tab>
        <template v-if="selectedBot.pageid == '853384435005817'">
          <v-tab href="#BearhouseOrder" ripple>{{ $t('Order Summary') }} 2</v-tab>
          <!-- <v-tab href="#bearhouse-order2" ripple>{{$t('Order Summary')}} 3</v-tab> -->
        </template>
        <v-tab href="#Promotion" ripple>{{ $t('Coupon') }}</v-tab>
        <v-tab href="#Wholesale" ripple>{{ $t('All Wholesale') }}</v-tab>
        <v-tab href="#Payment" ripple>{{ $t('Payments') }}</v-tab>

        <v-tab href="#ShippingMethod" ripple>{{ $t('Shipping Method') }}</v-tab>
      </v-tabs>
      <div v-if="currentView == 'Products'">
        <component
          :is="$store.state.subcategory.includes(selectedBot.pageid) ? 'KanomProducts' : 'Products'"
        ></component>
      </div>
      <div v-else-if="currentView == 'ecommerce-order-summary'">
        <component :is="'ecommerce-order-summary'"></component>
      </div>
      <div v-else-if="currentView == 'nvbb-order-summary'">
        <component :is="'nvbb-order-summary'"></component>
      </div>
      <div v-else-if="currentView == 'aston-ads'">
        <aston-ads></aston-ads>
      </div>
      <div v-else-if="currentView == 'aston-auction'">
        <aston-auction></aston-auction>
      </div>
      <div v-else-if="currentView == 'wholesale'">
        <wholesale></wholesale>
      </div>
      <div v-else-if="currentView == 'payment'">
        <payment></payment>
      </div>
      <div v-else-if="currentView == 'bearhouse-order'">
        <bearhouse-order></bearhouse-order>
      </div>
      <div v-else-if="currentView == 'bearhouse-order2'">
        <bearhouse-order2></bearhouse-order2>
      </div>
      <div v-else-if="currentView == 'ProductAnalytics'">
        <product-analytics v-if="showProductAnalytic"></product-analytics>
      </div>
      <div v-else-if="currentView == 'cartsummary'">
        <cart-summary></cart-summary>
      </div>
      <div v-else-if="currentView == 'promotion'">
        <promotion></promotion>
      </div>
    </div>
    <div v-else>
      <template-empty></template-empty>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Products from './Products'
import KanomProducts from './KanomProducts'
import Payment from './Payment'
import EcommerceOrderSummary from './ecommerce-order-summary'
import NvbbOrderSummary from './nvbb-order-summary'
import TemplateEmpty from '@/components/view/template/template-empty'
import Wholesale from './Wholesale'
import AstonAds from './AstonAds'
import BearhouseOrder from './BearhouseOrder'
import BearhouseOrder2 from './BearhouseOrder2'
import ProductAnalytics from './ProductAnalytics.vue'
import AstonAuction from './AstonAuction.vue'
import CartSummary from './CartSummary.vue'
import Promotion from './Promotion.vue'
import ShippingMethod from './ShippingMethod.vue'
import Shippop from './Shippop.vue'

export default {
  data: function () {
    return {
      currentView: 'products',
    }
  },
  components: {
    TemplateEmpty,
    Products,
    KanomProducts,
    EcommerceOrderSummary,
    Payment,
    Wholesale,
    AstonAds,
    BearhouseOrder,
    BearhouseOrder2,
    ProductAnalytics,
    AstonAuction,
    NvbbOrderSummary,
    CartSummary,
    Promotion,
    ShippingMethod,
    Shippop,
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      // switch (vm.$route.query.tab) {
      //   case 'products':
      //   case 'ecommerce-category':
      //   case 'ecommerce-order-summary':
      //   case 'bearhouse-order':
      //   case 'wholesale':
      //   case 'aston-auction':
      //   case 'product-analytic':
      //   case 'cart-summary':
      //   case 'payment':
      //   case 'promotion':
      //     vm.currentView = vm.$route.query.tab
      //     break
      //   default:
      //     vm.currentView = 'products'
      //     break
      // }
      vm.currentView = vm.$route.query.tab
    } else {
      vm.currentView = 'Products'
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getBotPageRole: 'getBotPageRole',
      isFacebook: 'isFacebook',
    }),
    // ecommerceComponent() {
    //   const component_name = this.currentView
    //   return () => import(`./${component_name}.vue`)
    // },

    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    },
    showProductAnalytic() {
      return (
        this.getBotPageRole ||
        ['361231620965547', '853384435005817'].includes(this.selectedBot.pageid) ||
        !this.isFacebook
      )
    },
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView,
        },
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce.vue